import { get } from "../../service/api";

const GetPoses = async (queryString = "") => {
  try {
    const extra = queryString
      ? queryString.startsWith("&") || queryString.startsWith("?")
        ? queryString
        : `&${queryString}`
      : "";
    const response = await get(`/pos?1=1${extra}`);
    return response;
  } catch (error) {
    console.error("Error GetPoses:", error);
    throw error;
  }
};

export default GetPoses;
